import React from 'react';

import AnalyticsPageContent from 'components/dashboard/analytics-content/AnalyticsPageContent';

const DashboardAnalyticsPage = () => <AnalyticsPageContent />;

export default DashboardAnalyticsPage;
